module.exports = __webpack_public_path__ + "img/davide-marchet-web-designer-low.b70c84c2.jpg";